module.exports = __webpack_public_path__ + "static/media/AutorinnenPortrait_LilianeZuuring.e39cb9cd.jpg";